import classNames from 'classnames';
import React from 'react';
import { CardHeaderSC, clsPrefix } from './card-header.styled';
import CardHeaderAvatar from './components/card-header-avatar';
import CardHeaderRightText from './components/card-header-right-text';

interface CardHeaderProps {
  left?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const CardHeader = ({ className, left, right, style, title, description }: CardHeaderProps) => {
  return (
    <CardHeaderSC className={classNames(clsPrefix, className)} style={style}>
      {left}
      <div className={`${clsPrefix}-content`}>
        {title ? <div className={`${clsPrefix}-title`}>{title}</div> : null}
        {description ? <div className={`${clsPrefix}-description`}>{description}</div> : null}
      </div>
      {right}
    </CardHeaderSC>
  );
};

CardHeader.AvatarLeft = CardHeaderAvatar;
CardHeader.TextRight = CardHeaderRightText;

export default CardHeader;
